module.exports = __webpack_public_path__ + "img/bind.dc44f120.png";